import classNames from 'classnames';

import iconAmex from '../../assets/amex@2x.png';
import iconCarteBancaire from '../../assets/cartebancaire@2x.png';
import iconDiners from '../../assets/diners@2x.png';
import iconMaestro from '../../assets/maestro@2x.png';
import iconMc from '../../assets/mc@2x.png';
import iconVisa from '../../assets/visa@2x.png';
import { CardType, Nullable } from '../../types';

import styles from './CardIcon.module.scss';

export type CardIconProps = {
  type: Nullable<CardType>;
  className?: string;
};

const IMAGES: { [key in CardType]: string | undefined } = {
  visa: iconVisa,
  mastercard: iconMc,
  'diners-club': iconDiners,
  'american-express': iconAmex,
  maestro: iconMaestro,
  discover: undefined,
  jcb: undefined,
  unionpay: undefined,
  elo: undefined,
  mir: undefined,
  hiper: undefined,
  hipercard: undefined,
  cartebancaire: iconCarteBancaire,
};

const CardIcon: React.FC<CardIconProps> = ({ className, type }) => {
  const image = type ? IMAGES[type] : null;
  const alt = type ? type : '';
  return image ? (
    <img
      src={image}
      className={classNames(styles.cardIcon, className)}
      alt={alt}
      data-zta="ccImage"
    />
  ) : null;
};

export default CardIcon;
